export * from './lib/shared-data-access.module';
export * from './lib/api.service'
